// 🔧 passport_step.js
// ✅ Purpose: Pipeline step for the LGV Passport Engine
// ✅ Features:
// - Executes the Passport Engine when Passport is selected
// - Runs after other add-ons so Passport can attach to created demo data
// - Integrates with shared DemoContext
// - Returns standardized pipeline results
// - Fully block-commented for clarity and future devs

import { runPassportEngine } from "../../engines/passport";

export const createPassportStep = () => ({
  id: "passport_builder",

  name: "Passport Builder",

  label: "Passport Builder",

  run: async (demoContext) => {
    console.log("🛂 Passport Pipeline Step started.");

    const result = await runPassportEngine({
      demoContext,
    });

    console.log("✅ Passport Pipeline Step completed.", {
      result,
    });

    return result;
  },
});